<script lang="ts">
  import { type FaceValue } from "@briefmarken_katalog/types";
  import './row.css'
  let { data }: { data: FaceValue } = $props();
</script>

<div class="field">{data ? data.value : ""} {data ? data.unit : ""}</div>
